import { FC } from 'react'
import { Form } from 'react-bootstrap'
import { FieldProps } from '../Forms.d'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'

const TextAreaField: FC<FieldProps> = ({
    id,
    label = '',
    showLabel = true,
    name,
    formikProps,
    placeholder = '',
    groupClassName = '',
    className = '',
    required = false,
    disabled = false,
    readonly = false,
}) => {
    const { values, errors, touched, handleChange } = formikProps

    return (
        <Form.Group
            className={
                (groupClassName || '') +
                ' sfy-field mb-3' +
                (required ? ' required' : '')
            }
            controlId={id}
        >
            {showLabel && (
                <Form.Label>
                    {label}{' '}
                    {required && (
                        <FontAwesomeIcon
                            icon={faAsterisk}
                            className="text-danger"
                            size="xs"
                        />
                    )}
                </Form.Label>
            )}
            <Form.Control
                as="textarea"
                rows={3}
                name={name}
                value={values[name] || ''}
                onChange={handleChange}
                placeholder={placeholder}
                className={
                    (className || '') +
                    ' ' +
                    (errors[name] && touched[name] ? 'is-invalid' : '') +
                    (readonly ? ' readonly' : '')
                }
                disabled={disabled}
                readOnly={readonly}
            />
            <span className="bottom-border"></span>
            {errors[name] && touched[name] && (
                <Form.Text className="invalid-feedback">
                    {errors[name].toString()}
                </Form.Text>
            )}
        </Form.Group>
    )
}

export default TextAreaField
